import { RootDeviceTypeRoute, RootDeviceTypeLink, RootDeviceTypeItemRoute, RootDeviceTypeItemInfoRoute, RootDeviceTypeItemInfoLink } from "./rootDeviceType/index.js";
import { RootDeviceGroupRoute, RootDeviceGroupLink, RootDeviceGroupItemRoute, RootDeviceGroupItemInfoRoute, RootDeviceGroupItemInfoLink } from "./rootDeviceGroup/index.js";
import { RootFirmwareReleaseItemInfoLink, RootFirmwareReleaseItemInfoRoute, RootFirmwareReleaseItemRoute, RootFirmwareReleaseLink, RootFirmwareReleaseRoute } from "./rootFirmwareRelease/index.js";
import { RootFirmwareApplicationItemInfoLink, RootFirmwareApplicationItemInfoRoute, RootFirmwareApplicationItemRoute, RootFirmwareApplicationLink, RootFirmwareApplicationRoute } from "./rootFirmwareApplication/index.js";
import { RootFirmwareComponentItemInfoLink, RootFirmwareComponentItemInfoRoute, RootFirmwareComponentItemRoute, RootFirmwareComponentLink, RootFirmwareComponentRoute } from "./rootFirmwareComponent/index.js";
import { RootDeviceRoute, RootDeviceLink, RootDeviceItemInfoRoute, RootDeviceItemRoute, RootDeviceItemInfoLink } from "./rootDevice/index.js";
import { install } from "./PluginSetup.js";
export default {
  RootDeviceTypeRoute,
  RootDeviceTypeLink,
  RootDeviceTypeItemRoute,
  RootDeviceTypeItemInfoRoute,
  RootDeviceTypeItemInfoLink,
  RootDeviceGroupRoute,
  RootDeviceGroupLink,
  RootDeviceGroupItemRoute,
  RootDeviceGroupItemInfoRoute,
  RootDeviceGroupItemInfoLink,
  RootFirmwareReleaseItemInfoLink,
  RootFirmwareReleaseItemInfoRoute,
  RootFirmwareReleaseItemRoute,
  RootFirmwareReleaseLink,
  RootFirmwareReleaseRoute,
  RootFirmwareApplicationItemInfoLink,
  RootFirmwareApplicationItemInfoRoute,
  RootFirmwareApplicationItemRoute,
  RootFirmwareApplicationLink,
  RootFirmwareApplicationRoute,
  RootFirmwareComponentItemInfoLink,
  RootFirmwareComponentItemInfoRoute,
  RootFirmwareComponentItemRoute,
  RootFirmwareComponentLink,
  RootFirmwareComponentRoute,
  RootDeviceRoute,
  RootDeviceLink,
  RootDeviceItemInfoRoute,
  RootDeviceItemRoute,
  RootDeviceItemInfoLink,
  install
};